import useSWR from "swr";

export interface SubscriptionPolicy {
  allowSelfCancellation: boolean;
  cancellationText: string;
  cancellationDayOfMonth: number;
  cancellationGracePeriodMonths: number;
}

interface UseSubscriptionPolicyQueryReturn {
  data: SubscriptionPolicy | undefined;
}

export function useSubscriptionPolicyQuery(
  membershipPlanId?: string
): UseSubscriptionPolicyQueryReturn {
  const { data } = useSWR(
    membershipPlanId
      ? `/api/v2/membership_plans/${membershipPlanId}/policy`
      : null
  );

  return { data: toSubscriptionPolicy(data?.data) };
}

function toSubscriptionPolicy(data?: any): SubscriptionPolicy | undefined {
  try {
    if (data) {
      return {
        allowSelfCancellation: data.allow_self_cancellation,
        cancellationText: data.cancellation_text,
        cancellationDayOfMonth: data.cancellation_day_of_month,
        cancellationGracePeriodMonths: data.cancellation_grace_period_months,
      };
    }
  } catch {
    throw new Error("Error mapping data");
  }
}
